import React, { useEffect, useState } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import CardMobileSection from 'components/sales/tableSection/cardMobileSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { STATUS } from 'constants/statusConstant';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import './siteListing.css';
const SiteListing = ({
  getTaskListing,
  siteListData,
  getSiteFilters,
  siteFilters,
  userProfile,
  getLocationChange,
  locationChange,
}) => {
  const [listData, setListData] = useState();
  const [cardListData, setCardListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const headers = [
    'Site Number',
    'Site Type',
    'Client Name',
    'No.of Gates',
    'Area Name',
    'Assigned To',
    'Assigned To Maintenance',
    'Start Date',
    'Handover Date',
    (isRoleId === STATUS.CITY_HEAD ||
      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
      'Validate Location',
    'Status',
    'Actions',
  ];
  const cardHeaders = [
    'Site Number',
    'Site Type',
    'Client Name',
    'Area Name',
    'Start Date',
    'Handover Date',
    (isRoleId === STATUS.CITY_HEAD ||
      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
    'Validate Location',
    'Status',
    'Actions',
  ];

    async function fetchAttData() {
        try {
          // fetchAttd
            const url = `${Config.attendance.fetchAttd}`;

            const { data } = await axios.get(url);
            console.log(data.response.data)
            // setData(data?.response?.data);
        } catch {
            console.log('Something went wrong');
        }
    }

  useEffect(() => {
    fetchAttData();
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setIsRoleId(roles[0].pivot.role_id);
      })();
    }, 1000);
  }, []);

  useEffect(() => {
    
    if (getTaskListing !== null)
      (async () => {
        setIsLoading(true);
        await getTaskListing();
        setIsLoading(false);
      })();
  }, [getTaskListing]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {
    const actions1 =
      isRoleId === 9
        ? [
            { name: 'View Details', link: '/dashboard/lead-details' },
            { name: 'Site Log', link: '/dashboard/site-log' },
            { name: 'Set Target Date', link: '/dashboard/set-target-date' },
            { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
            { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
          ]
        : [
            { name: 'View Details', link: '/dashboard/lead-details' },
            { name: 'Site Log', link: '/dashboard/site-log' },
            { name: 'Set Target Date', link: '/dashboard/set-target-date' },
            { name: 'Change Assignee', link: '/dashboard/site-assignee' },
            { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
            { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
          ];
    const actions2 =
      isRoleId === 9
        ? [
            { name: 'View Details', link: '/dashboard/lead-details' },
            { name: 'Site Log', link: '/dashboard/site-log' },
            { name: 'Site Stages', link: '/dashboard/site-stage' },
            { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
            { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
          ]
        : [
            { name: 'View Details', link: '/dashboard/lead-details' },
            { name: 'Site Log', link: '/dashboard/site-log' },
            { name: 'Site Stages', link: '/dashboard/site-stage' },
            { name: 'Change Assignee', link: '/dashboard/site-assignee' },
            { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
            { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
          ];

    const tableData = [
      'site_id',
      'site_no',
      'lead_id',
      'site_type',
      'client_name',
      'gates',
      'area_name',
      'assigned_to',
      'assigned_to_maintenance',
      'created_at',
      'handover_date',
      (isRoleId === STATUS.CITY_HEAD ||
        isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
        'is_location_validate',
      'status',
    ];
    const cardTableData = [
      'site_id',
      'site_no',
      'lead_id',
      'site_type',
      'client_name',
      'area_name',
      'created_at',
      'handover_date',
      (isRoleId === STATUS.CITY_HEAD ||
        isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
        'is_location_validate',
      'status',
    ];
    // console.log(siteListData);
    if (siteListData && siteListData.resultSets) {
      const cardData = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...cardTableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              element.target_date_settled === 1
                ? element.status === 'In Maintenance'
                  ? [
                      { name: 'View Details', link: '/dashboard/lead-details' },
                      { name: 'Site Stages', link: '/dashboard/site-stage' },
                      {
                        name: 'Schedule Meeting',
                        link: '/dashboard/meeting-history',
                      },
                      {
                        name: 'Vendor Allocation',
                        link: '/dashboard/vendor-allocation',
                      },
                    ]
                  : actions2
                : actions1,
          }
        )
      );
      if (cardData) {
        const newCardData = cardData.map(function (obj) {
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newCardData && setCardListData(newCardData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }

    if (siteListData && siteListData.resultSets) {
      const data = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              element.target_date_settled === 1
                ? element.status === 'In Maintenance'
                  ? [
                      { name: 'View Details', link: '/dashboard/lead-details' },
                      { name: 'Site Stages', link: '/dashboard/site-stage' },
                      {
                        name: 'Schedule Meeting',
                        link: '/dashboard/meeting-history',
                      },
                      {
                        name: 'Vendor Allocation',
                        link: '/dashboard/vendor-allocation',
                      },
                    ]
                  : actions2
                : actions1,
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData, isRoleId]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getTaskListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Button
        onClick={filterToggle}
        className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
      >
        <img src={Images?.Filter} alt="" />
        <b className="site_filters" style={{width:"max-content"}}>
        {localization.showFilters}
        </b>
      </Button>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getTaskListing(filter, val.selected + 1);
    setIsLoading(false);
  };

  const updateLocation = (val) => {
    const isLocation = val.check === false ? 0 : 1;
    getLocationChange(val.id, isLocation);
  };

  useEffect(() => {
    (async () => {
      if (locationChange.status) {
        setIsLoading(true);
        await getTaskListing();
        setIsLoading(false);
      }
    })();
  }, [locationChange]);

  return (
    <Layout
      title={localization.siteList}
      isLoading={isLoading}
      // Buttons={headerBtns}
    >
     
      {/* {window.screen.width < 1000?
      <CardMobileSection
        data={cardListData}
        isId={false}
        isMngId={false}
        headers={cardHeaders}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.resultSets}
        srNo={siteListData?.from}
      />
      : */}
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.resultSets}
        srNo={siteListData?.from}
      />
      {/* } */}
      {/* <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters?.site_types ? siteFilters : null}
        siteFilters
      /> */}
    </Layout>
  );
};

export default SiteListing;
